import React from 'react';
import {
  AppliedChip,
  AppliedChipEl,
  AppliedChipsDivider,
  AppliedChipsList,
  AppliedChipsTitle,
  AppliedChipsWrap,
  AppliedChipWarning,
  AppliedChipX,
  ChipCategory
} from '../../components/V2ContextBar';

interface AppliedFiltersProps {
  chips: AppliedChip[];
  onRemove: (chipId: string) => void;
}

export const AppliedFilters: React.FC<AppliedFiltersProps> = ({
  chips,
  onRemove
}) => {
  if (chips.length === 0) return null;
  return (
    <AppliedChipsWrap>
      <AppliedChipsDivider />
      <AppliedChipsTitle>Applied filters</AppliedChipsTitle>
      <AppliedChipsList>
        {chips.map((chip) => (
          <AppliedChipEl key={chip.id}>
            <ChipCategory>{chip.category}</ChipCategory>
            {chip.label}
            {chip.warning && <AppliedChipWarning message={chip.warning} />}
            <AppliedChipX type="button" onClick={() => onRemove(chip.id)}>
              ×
            </AppliedChipX>
          </AppliedChipEl>
        ))}
      </AppliedChipsList>
    </AppliedChipsWrap>
  );
};
